import { useMemo } from 'react'
import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { useTranslation } from '@root/shared/localization'
import {
  Dialog,
  EyeClosedIcon,
  type DialogControlProps,
} from '@root/shared/ui-kit'

import { reatomBlacklistCurrenciesTable } from '../atoms/reatom-blacklist-currencies-table'

import { BlacklistCurrenciesTable } from './blacklist-currencies-table'

type BlacklistCurrenciesDialogProps = DialogControlProps

export const BlacklistCurrenciesDialog: React.FC<
  BlacklistCurrenciesDialogProps
> = ({ open, onOpenChange }) => {
  const { t } = useTranslation()
  const tableModel = useMemo(
    // eslint-disable-next-line @reatom/unit-naming-rule
    () => reatomBlacklistCurrenciesTable(),
    [],
  )

  return (
    <StyledDialog
      open={open}
      onOpenChange={onOpenChange}
      describedBy={t('blacklist-currencies.title')}
    >
      <Dialog.Header title={t('blacklist-currencies.title')} />
      <Body>
        <Intro>
          <IconWrap>
            <EyeClosedIcon size={18} />
          </IconWrap>
          <Description>{t('blacklist-currencies.description')}</Description>
        </Intro>
        <TableArea>
          <BlacklistCurrenciesTable tableModel={tableModel} />
        </TableArea>
      </Body>
    </StyledDialog>
  )
}

const StyledDialog = styled(Dialog)`
  width: 480px;
  height: 520px;
`

const Body = styled.div`
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
  gap: 12px;
  padding: 14px 14px 12px;
  min-height: 0;
  overflow: hidden;
`

const Intro = styled.div`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  gap: 12px;

  padding: 12px 14px;
  border-radius: 10px;
  background: var(--backgroundA-2);
  border: 1px solid var(--backgroundA-2);
`

const IconWrap = styled.div`
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--backgroundA-3);
  color: var(--text-11);
`

const Description = styled(Typography)`
  color: var(--text-10);
  line-height: 16px;
`

const TableArea = styled.div`
  display: grid;
  grid-template-rows: minmax(0, 1fr);
  min-height: 0;
  overflow: hidden;
  border-radius: 10px;
  border: 1px solid var(--backgroundA-2);
  background: var(--background-1);
`
